<template>
  <Section :title="gettext('Votre lieu de résidence')">
    <FormGroup :field="usageField" hide-label>
      <RadiosList
        :value="simulation.buildingUsage"
        @change="(val) => updateSimulation({ buildingUsage: val.target.value })"
      >
        <template #default="slotProps">
          <div class="h5 mrgv0">{{ slotProps.choice[1] }}</div>
        </template>
      </RadiosList>
    </FormGroup>

    <FormGroup v-if="!city" :field="altitudeField" class="mrgt">
      <RadiosList
        :value="simulation.buildingAltitude"
        @change="
          (val) => updateSimulation({ buildingAltitude: val.target.value })
        "
      >
        <template #default="slotProps">
          <div class="h5 mrgv0">{{ slotProps.choice[1] }}</div>
        </template>
      </RadiosList>
    </FormGroup>
  </Section>
</template>

<script setup>
import { computed } from 'vue';

import Section from '@/components/simulation/Section.vue';
import FormGroup from '@/components/forms/FormGroup.vue';
import RadiosList from '@/components/forms/fields/RadiosList.vue';
import { useSimulation } from '@/composables/useSimulation';

const { simulation, updateSimulation, city } = useSimulation();

const usageField = computed(() => {
  return {
    label: gettext('De quel type de résidence s’agit-il?'),
    name: 'building-usage',
    choices: [
      ['primary', gettext('Résidence principale')],
      ['secondary', gettext('Résidence secondaire')],
    ],
  };
});

const altitudeField = computed(() => {
  return {
    label: gettext('À quelle altitude se trouve le bâtiment?'),
    name: 'building-altitude',
    choices: [
      ['low', gettext('En plaine (≤ 1000 m)')],
      ['high', gettext('En montagne (> 1000 m)')],
    ],
  };
});
</script>
